import Flex from '@Components/Bases/Flex';
import { IReport } from '@Domains/Reports';
import { Box, Typography } from '@mui/material';
import CreateReportButton from '@Router/Landing/Containers/CreateReportButton';
import ReportDetail from '../ReportDetail/ReportDetail';

type ReportListProps = {
  data?: IReport[];
  refetch: () => void;
};

const ReportList = ({ data, refetch }: ReportListProps) => {
  if (data?.length === 0) {
    return (
      <Flex
        px={{ xs: 2, sm: 4 }}
        py={2}
        bgcolor="white"
        flexDirection="column"
        alignItems="center"
        borderRadius={1}
      >
        <Typography textAlign="center">
          ไม่พบ แบบรายงาน Corporate Value Up ที่อยู่ระหว่างรอดำเนินการ
          กรุณาสร้างรายงานด้วยการกดปุ่ม สร้างแบบรายงาน CVUP
        </Typography>
        <Box pt={2}>
          <CreateReportButton onSuccess={refetch} />
        </Box>
      </Flex>
    );
  }

  return (
    <Box>
      {data?.map((report, index) => (
        <ReportDetail
          key={index}
          reportDetail={report}
          refetch={refetch}
          allReports={data}
        />
      ))}
    </Box>
  );
};

export default ReportList;
